import { TranslationParameters } from '../service/language.service';

export enum MessageType {
  Error,
  Information,
  Success,
  Warning,
}

export class ShowMessageEvent {
  constructor(
    public type: MessageType,
    public message: string,
    public parameters?: TranslationParameters
  ) {}
}
